import React, { useState } from 'react';

//components
import Onboarding from '../components/Onboarding/Onboarding';
import { steps } from '../components/Onboarding/helpers/OnboardingHelpers';

const OnboardingView = (props) => {
    const { setFirstLogin } = props;
    const [activeStep, setActiveStep] = useState(0);

    const handleStepChange = (step) => {
        if (step !== 3) {
            setActiveStep(step);
        }
    };

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    return (
        <div
            className={'onboarding'}
            style={{
                width: '100vw',
                height: '105vh',
                background:
                    'linear-gradient(169deg, rgba(50, 85, 153, 0.10) 16.74%, rgba(102, 50, 153, 0.10) 83.26%)',
                backgroundSize: 'cover',
            }}
        >
            <Onboarding
                setFirstLogin={setFirstLogin}
                steps={steps}
                activeStep={activeStep}
                setActiveStep={setActiveStep}
                handleStepChange={handleStepChange}
                handleNext={handleNext}
                handleBack={handleBack}
            />
        </div>
    );
};

export default OnboardingView;
